export const swiperList = [
  {
    title: '一站式IT智能运维平台',
    content: '通过对业务系统的下属各网络设备、服务器、数据库、中间件、操作系统、存储设备、云平台等百余种平台服务和IT组件，实现一体化监控方案，打造智能立体化监控平台',
    img: require('../assets/index/index-banner1.jpg')
  },
  {
    title: '批量资产秒级接入',
    content: '通过代理或无代理的部署方式，实现IT资产的快速接入。代理目前支持 CentOS、Ubuntu、Debian、Fedora、RedHat、Windows、SUSE、HPUX、Solaris、Tru64、FreeBSD等主流通用操作系统',
    img: require('../assets/index/index-banner2.png')
  },
  {
    title: '专业的定制化服务',
    content: '针对不同用户的需求，提供可定制化的服务，实现量身定制的IT运维解决方案',
    img: require('../assets/index/index-banner1.jpg')
  }
]

export const swiperListM = [
  {
    title: '一站式IT智能运维平台',
    content: '通过对业务系统的下属各网络设备、服务器、数据库、中间件、操作系统、存储设备、云平台等百余种平台服务和IT组件，实现一体化监控方案，打造智能立体化监控平台',
    img: require('../assets/index/index-banner1-m.jpg')
  },
  {
    title: '批量资产秒级接入',
    content: '通过代理或无代理的部署方式，实现IT资产的快速接入。代理目前支持 CentOS、Ubuntu、Debian、Fedora、RedHat、Windows、SUSE、HPUX、Solaris、Tru64、FreeBSD等主流通用操作系统',
    img: require('../assets/index/index-banner2-m.jpg')
  },
  {
    title: '专业的定制化服务',
    content: '针对不同用户的需求，提供可定制化的服务，实现量身定制的IT运维解决方案',
    img: require('../assets/index/index-banner1-m.jpg')
  }
]
